import {createStylesParams, StyleParamType, wixFontParam} from '@wix/tpa-settings';

type IStylesParams = {
  cart_textFontStyle: StyleParamType.Font;
};

export default createStylesParams<IStylesParams>({
  cart_textFontStyle: {
    type: StyleParamType.Font,
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
  },
});
